import FabricCanvasTool from '../fabrictool'

import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric'

class DashedLine extends FabricCanvasTool {
  configureCanvas(props) {
    const canvas = this._canvas
    canvas.isDrawingMode = canvas.selection = false
    canvas.defaultCursor = 'default'
    canvas.forEachObject((obj) => {
      if (
        !obj.id ||
        (obj.id &&
          !obj.id.includes('pageItem') &&
          !obj.id.includes('gapFillingItem'))
      ) {
        obj.selectable = obj.evented = false
      }
    })
    this._width = props.lineWidth
    this._color = props.lineColor
  }

  doMouseDown(o) {
    this.isDown = true
    const canvas = this._canvas
    const pointer = canvas.getPointer(o.e)
    const points = [pointer.x, pointer.y, pointer.x, pointer.y]
    this.line = new fabric.Line(points, {
      strokeWidth: this._width,
      fill: this._color,
      stroke: this._color,
      strokeDashArray: [10, 10],
      originX: 'center',
      originY: 'center',
      selectable: false,
      evented: false
    })
    canvas.add(this.line)
  }

  doMouseMove(o) {
    if (!this.isDown) return
    const canvas = this._canvas
    const pointer = canvas.getPointer(o.e)
    this.line.set({ x2: pointer.x, y2: pointer.y })
    this.line.setCoords()
    canvas.renderAll()
  }

  doMouseUp() {
    this.isDown = false
  }

  doMouseOut() {
    this.isDown = false
  }
}

export default DashedLine
